3
/**
 * @description Hook utilizado para funções relacionadas a histórico das entidades
 * @author Diego Sabino Amorim de Araújo
 * @file useHistoricoService.js
 * @license Copyright (c) 2023 SIGEP DIGETI ITEP/RN
 */

import { useFetch } from './useFetch'

export const useHistoricoService = () => {
  const fetch = useFetch()

  const listarHistoricoAsync = async (id, tipo, setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      let rota = null
      switch (tipo) {
        case 'CASO': {
          rota = `/casos/historico/${id}`
          break
        }
        case 'VESTIGIO': {
          rota = `/vestigios/historico/${id}`
          break
        }
        case 'CADAVER': {
          rota = `/cadaver/historico/${id}`
          break
        }
        case 'PERICIANDO': {
          break
        }
        case 'VEICULO': {
          break
        }
        case 'SOLICITACAO_EXAME': {
          rota = `/solicitacoesexame/historico/${id}`
          break
        }
        case 'EXAME_SOLICITADO': {
          rota = `/exameSolicitado/historico/${id}`
          break
        }
        default: {
          break
        }
      }

      if (rota) {
        const response = await fetch.get(rota)

        return response.data.operacoes
      }
    } catch (err) {
      return null
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  return {
    listarHistoricoAsync,
  }
}

//OPERAÇÕES TODAS AS ENTIDADES

// CADASTROU
// EDITOU
// EXCLUIU

// OPERAÇÕES VESTÍGIO

// SOLICITOU ENCAMINHAMENTO,
// CANCELOU ENCAMINHAMENTO,
// ACEITOU ENCAMINHAMENTO,
// NEGOU ENCAMINHAMENTO
// SOLICITOU PASSAGEM DE CUSTÓDIA
// CANCELOU PASSAGEM DE CUSTÓDIA
// NEGOU PASSAGEM DE CUSTÓDIA
// ACEITOU PASSAGEM DE CUSTÓDIA
// RETIROU,
// GUARDOU,
// ENTREGOU AO DESTINO,
// ADICIONOU INFORMAÇÃO,
// CONSUMIU VESTÍGIO,
// TORNOU CONTRAPROVA
// DESCARTOU

// OPERAÇÕES CADAVER

// EXTRAIU VESTÍGIO (CADAVER, VESTÍGIO, PERICIANDO, VEICULO)
// RECONHECEU
// LIBEROU
// ENTREGOU

/// CRIAR ROTA ÚNICA TIPO GET (RODA/TIPO/ID)

// SELECT * FROM HISTORICO WHERE
